/* =============================================================================
   Akademija Starfy - interaktivni prikazi
   =============================================================================
   Stiri moduli. Vsak obstaja zato, ker podira eno napacno predstavo, ki
   zacetnike stane denarja:

     1. ZBIRANJE SVETLOBE - "vecja povecava = bolje". Ne. Steje ploscina
        objektiva, ta pa raste s KVADRATOM premera. Dvakrat vecji premer je
        stirikrat vec svetlobe. To je edina stevilka, ki odloca, koliko boste
        videli.
     2. POVECAVA - "675x" na skatli. Uporabna povecava se konca pri priblizno
        2x premer v milimetrih; cez to se slika samo poveca, ne pa razkrije.
     3. POT SVETLOBE - zakaj so trije dizajni razlicno dolgi in zakaj ima
        Newton zrcalce sredi cevi.
     4. SLEDENJE - zakaj brez ekvatorialne montaze fotografija ne gre, tudi
        ce teleskop objekt drzi na sredini.

   Vse risemo v SVG, ker se mora ostro izrisati na vsakem zaslonu in ker so
   crte, ki jih premikamo, isti elementi, ki jih bralec vidi.
   ========================================================================== */
(function () {
  "use strict";

  var NS = "http://www.w3.org/2000/svg";
  var EYE_PUPIL = 7;           // mm, razsirjena zenica odraslega
  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function fmt(n, d) { return n.toFixed(d == null ? 0 : d).replace(".", ","); }

  /* =========================================================================
     1. ZBIRANJE SVETLOBE
     ========================================================================= */
  (function apertureModule() {
    var host = document.querySelector("[data-ak-aperture]");
    if (!host) return;

    var slider = host.querySelector("input[type=range]");
    var svg = host.querySelector("svg");
    var outD = host.querySelector("[data-out-d]");
    var outArea = host.querySelector("[data-out-area]");
    var outEye = host.querySelector("[data-out-eye]");
    var outMag = host.querySelector("[data-out-limit]");
    var outNote = host.querySelector("[data-out-note]");

    var W = 560, H = 260;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);

    // referencni krog: clovesko oko, vedno na istem mestu in nespremenjen -
    // primerjava je vredna samo, ce se referenca ne premika
    var scale = 0.42;                       // px na mm premera
    var eyeR = (EYE_PUPIL * scale) / 2;
    el("circle", { cx: 96, cy: H / 2, r: eyeR, fill: "#7fb6ff", opacity: ".9" }, svg);
    el("text", { x: 96, y: H / 2 + 34, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "12" }, svg)
      .textContent = "vaše oko (7 mm)";

    var scopeC = el("circle", { cx: 360, cy: H / 2, r: 20, fill: "url(#akGlow)", stroke: "#a9d4ff", "stroke-width": "1.5" }, svg);
    var scopeLabel = el("text", { x: 360, y: H - 18, "text-anchor": "middle", fill: "#eef3fb", "font-size": "13", "font-weight": "600" }, svg);

    // pike, ki ponazarjajo ujeto svetlobo: koliko jih je, je sorazmerno s ploscino
    var dots = el("g", { opacity: ".85" }, svg);

    function draw() {
      var d = +slider.value;
      var r = Math.max(6, (d * scale) / 2);
      scopeC.setAttribute("r", r);
      scopeLabel.textContent = d + " mm";

      var area = Math.PI * Math.pow(d / 2, 2);
      var eyeArea = Math.PI * Math.pow(EYE_PUPIL / 2, 2);
      var ratio = area / eyeArea;

      outD.textContent = d + " mm";
      outArea.textContent = fmt(area / 100, 1) + " cm²";
      outEye.textContent = fmt(ratio) + "×";
      outMag.textContent = fmt(d * 2) + "×";

      // zvezdna velicina, ki jo teleskop se pokaze (priblizek za temno nebo)
      var limit = 7.5 + 5 * Math.log10(d / EYE_PUPIL);
      outNote.textContent = "Pri temnem nebu pokaže zvezde do približno " + fmt(limit, 1) +
        ". magnitude - prostemu očesu jih je vidnih do 6.";

      // pike: ena na vsakih ~14 kvadratnih milimetrov, omejeno navzgor
      while (dots.firstChild) dots.removeChild(dots.firstChild);
      var n = Math.min(420, Math.round(area / 90));
      for (var i = 0; i < n; i++) {
        var a = Math.random() * Math.PI * 2;
        var rr = Math.sqrt(Math.random()) * (r - 2);
        el("circle", { cx: 360 + Math.cos(a) * rr, cy: H / 2 + Math.sin(a) * rr, r: 1.1, fill: "#fff", opacity: 0.55 + Math.random() * 0.45 }, dots);
      }
    }

    slider.addEventListener("input", draw);
    draw();
  })();

  /* =========================================================================
     2. POVECAVA
     ========================================================================= */
  (function magnificationModule() {
    var host = document.querySelector("[data-ak-mag]");
    if (!host) return;

    var fScope = host.querySelector("[data-in-focal]");
    var fEye = host.querySelector("[data-in-eyepiece]");
    var aper = host.querySelector("[data-in-aperture]");
    var outMag = host.querySelector("[data-out-mag]");
    var outMax = host.querySelector("[data-out-max]");
    var outVerdict = host.querySelector("[data-out-verdict]");
    var svg = host.querySelector("svg");

    var W = 560, H = 300;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);

    // Luna kot merilo: pri 0,5 stopinje je edini objekt, katerega velikost
    // vsak pozna na pamet.
    var frame = el("circle", { cx: W / 2, cy: H / 2, r: 108, fill: "#050912", stroke: "#2a3c5e", "stroke-width": "2" }, svg);
    var moon = el("circle", { cx: W / 2, cy: H / 2, r: 20, fill: "#d9e6f7" }, svg);
    var craters = el("g", { opacity: ".55" }, svg);
    var blur = el("circle", { cx: W / 2, cy: H / 2, r: 20, fill: "none", stroke: "#ffd08a", "stroke-width": "0", opacity: ".7" }, svg);
    el("text", { x: W / 2, y: H - 12, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "12" }, svg)
      .textContent = "pogled skozi okular - Luna meri 0,5°";

    function draw() {
      var fs = +fScope.value, fe = +fEye.value, ap = +aper.value;
      var mag = fs / fe;
      var max = ap * 2;
      outMag.textContent = fmt(mag) + "×";
      outMax.textContent = fmt(max) + "×";

      // Luna zavzame delez vidnega polja; polje pada z narascajoco povecavo
      var moonR = Math.min(320, 20 * (mag / 40));
      moon.setAttribute("r", moonR);

      while (craters.firstChild) craters.removeChild(craters.firstChild);
      var detail = Math.min(60, Math.round(mag / 3));
      for (var i = 0; i < detail; i++) {
        var a = (i * 2.399), rr = Math.sqrt((i + 1) / detail) * moonR * 0.85;
        el("circle", { cx: W / 2 + Math.cos(a) * rr, cy: H / 2 + Math.sin(a) * rr,
          r: Math.max(1, moonR / 26), fill: "#8ea3bd", opacity: ".7" }, craters);
      }

      // Cez uporabno mejo se slika samo napihne. Zamegljenost narise, kar
      // katalogi zamolcijo: "675x" ne pomeni vec podrobnosti, ampak manj.
      var over = mag / max;
      if (over > 1) {
        blur.setAttribute("r", moonR);
        blur.setAttribute("stroke-width", Math.min(26, (over - 1) * 34));
        moon.setAttribute("opacity", Math.max(.35, 1 - (over - 1) * .7));
        craters.setAttribute("opacity", Math.max(.05, .55 - (over - 1) * .5));
      } else {
        blur.setAttribute("stroke-width", "0");
        moon.setAttribute("opacity", "1");
        craters.setAttribute("opacity", ".55");
      }

      var v = outVerdict;
      v.classList.remove("is-ok", "is-warn", "is-bad");
      if (over <= 1) { v.classList.add("is-ok"); v.textContent = "V redu. Ta povečava je znotraj tega, kar optika zmore pokazati."; }
      else if (over <= 1.5) { v.classList.add("is-warn"); v.textContent = "Na meji. Slika bo mehka, podrobnosti ne bo nič več."; }
      else { v.classList.add("is-bad"); v.textContent = "Prazna povečava. Slika je večja in slabša - to je tista številka, ki jo pišejo na škatle."; }
    }

    [fScope, fEye, aper].forEach(function (i) { i.addEventListener("input", draw); });
    draw();
  })();

  /* =========================================================================
     3. POT SVETLOBE
     ========================================================================= */
  (function lightPathModule() {
    var host = document.querySelector("[data-ak-path]");
    if (!host) return;

    var svg = host.querySelector("svg");
    var desc = host.querySelector("[data-out-desc]");
    var buttons = host.querySelectorAll("[data-design]");
    var W = 620, H = 240;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);

    var DESIGNS = {
      refraktor: {
        naslov: "Refraktor - leča spredaj",
        opis: "Svetloba gre skozi lečo, ki jo zlomi in zbere v gorišču na drugem koncu cevi. " +
              "Cev je zato dolga toliko kot goriščna razdalja. Ni zrcalca sredi poti, zato je slika " +
              "kontrastna - a leča različne barve lomi različno, kar pri cenejših pokaže vijoličen rob.",
        rays: function (g) {
          for (var i = -3; i <= 3; i++) {
            var y = H / 2 + i * 16;
            el("path", { d: "M20 " + y + " L200 " + y + " L560 " + (H / 2), stroke: "#7fb6ff", "stroke-width": "1.4", fill: "none", opacity: ".85" }, g);
          }
          el("ellipse", { cx: 200, cy: H / 2, rx: 9, ry: 56, fill: "rgba(160,210,255,.22)", stroke: "#a9d4ff", "stroke-width": "1.6" }, g);
          el("circle", { cx: 560, cy: H / 2, r: 4, fill: "#ffd08a" }, g);
          label(g, 200, H / 2 - 70, "leča");
          label(g, 560, H / 2 - 22, "gorišče");
        }
      },
      newton: {
        naslov: "Newton - zrcalo zadaj",
        opis: "Svetloba pade na vbočeno zrcalo na dnu cevi, se odbije nazaj in jo majhno ravno " +
              "zrcalce vrže vstran, v okular na boku. Zrcala barv ne lomijo, zato ni barvnega roba, " +
              "in velik premer je tu najcenejši - zato so Dobsoni tako priljubljeni za globoko vesolje.",
        rays: function (g) {
          for (var i = -3; i <= 3; i++) {
            var y = H / 2 + i * 16;
            el("path", { d: "M20 " + y + " L520 " + y, stroke: "#7fb6ff", "stroke-width": "1.4", fill: "none", opacity: ".85" }, g);
            el("path", { d: "M520 " + y + " L200 " + (H / 2 - i * 3), stroke: "#8fd0ff", "stroke-width": "1.2", fill: "none", opacity: ".7" }, g);
          }
          el("path", { d: "M520 " + (H / 2 - 62) + " Q542 " + (H / 2) + " 520 " + (H / 2 + 62), fill: "none", stroke: "#a9d4ff", "stroke-width": "3" }, g);
          el("line", { x1: 186, y1: H / 2 - 22, x2: 214, y2: H / 2 + 22, stroke: "#ffd08a", "stroke-width": "3" }, g);
          el("path", { d: "M200 " + (H / 2) + " L200 " + (H / 2 - 78), stroke: "#8fd0ff", "stroke-width": "1.4", opacity: ".8" }, g);
          el("circle", { cx: 200, cy: H / 2 - 82, r: 4, fill: "#ffd08a" }, g);
          label(g, 540, H / 2 - 76, "glavno zrcalo");
          label(g, 200, H / 2 - 96, "okular");
        }
      },
      maksutov: {
        naslov: "Maksutov-Cassegrain - dvakrat naprej in nazaj",
        opis: "Svetloba gre skozi korekcijsko lečo, se odbije od zrcala zadaj, nato še od zrcalca " +
              "spredaj in skozi luknjo v glavnem zrcalu ven zadaj. Pot je prepognjena, zato je cev " +
              "kratka, goriščna razdalja pa dolga - natanko to, kar hočete za planete.",
        rays: function (g) {
          for (var i = -2; i <= 2; i++) {
            var y = H / 2 + i * 18;
            el("path", { d: "M40 " + y + " L500 " + y, stroke: "#7fb6ff", "stroke-width": "1.4", fill: "none", opacity: ".85" }, g);
            el("path", { d: "M500 " + y + " L180 " + (H / 2 + i * 7), stroke: "#8fd0ff", "stroke-width": "1.2", fill: "none", opacity: ".7" }, g);
            el("path", { d: "M180 " + (H / 2 + i * 7) + " L600 " + (H / 2), stroke: "#9fd8ff", "stroke-width": "1.1", fill: "none", opacity: ".6" }, g);
          }
          el("ellipse", { cx: 40, cy: H / 2, rx: 7, ry: 52, fill: "rgba(160,210,255,.18)", stroke: "#a9d4ff", "stroke-width": "1.4" }, g);
          el("path", { d: "M500 " + (H / 2 - 56) + " Q522 " + (H / 2) + " 500 " + (H / 2 + 56), fill: "none", stroke: "#a9d4ff", "stroke-width": "3" }, g);
          el("path", { d: "M180 " + (H / 2 - 20) + " Q166 " + (H / 2) + " 180 " + (H / 2 + 20), fill: "none", stroke: "#ffd08a", "stroke-width": "3" }, g);
          el("circle", { cx: 604, cy: H / 2, r: 4, fill: "#ffd08a" }, g);
          label(g, 40, H / 2 - 66, "korekcijska leča");
          label(g, 180, H / 2 - 40, "sekundarno zrcalo");
        }
      }
    };

    function label(g, x, y, t) {
      var n = el("text", { x: x, y: y, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "11" }, g);
      n.textContent = t;
    }

    function show(key) {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      el("rect", { x: 0, y: 0, width: W, height: H, fill: "#050912", rx: 12 }, svg);
      var g = el("g", {}, svg);
      var d = DESIGNS[key];
      d.rays(g);
      desc.innerHTML = "<strong>" + d.naslov + "</strong><br>" + d.opis;
      buttons.forEach(function (b) { b.classList.toggle("is-on", b.getAttribute("data-design") === key); });
      if (!reduced) {
        g.style.opacity = "0";
        requestAnimationFrame(function () { g.style.transition = "opacity .45s ease"; g.style.opacity = "1"; });
      }
    }

    buttons.forEach(function (b) {
      b.addEventListener("click", function () { show(b.getAttribute("data-design")); });
    });
    show("refraktor");
  })();

  /* =========================================================================
     4. SLEDENJE IN POLARNA PORAVNAVA
     ========================================================================= */
  (function trackingModule() {
    var host = document.querySelector("[data-ak-track]");
    if (!host) return;

    var svg = host.querySelector("svg");
    var modeBtns = host.querySelectorAll("[data-mode]");
    var expo = host.querySelector("[data-in-expo]");
    var outExpo = host.querySelector("[data-out-expo]");
    var verdict = host.querySelector("[data-out-track]");
    var W = 560, H = 300, CX = W / 2, CY = H / 2;
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);
    var mode = "azimut";

    function draw() {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
      el("rect", { x: 0, y: 0, width: W, height: H, fill: "#050912", rx: 12 }, svg);
      var sec = +expo.value;
      outExpo.textContent = sec < 60 ? sec + " s" : fmt(sec / 60, 1) + " min";

      // nebo se zavrti za 15 stopinj na uro
      var deg = (sec / 3600) * 15;
      var rad = deg * Math.PI / 180;

      var stars = [];
      for (var i = 0; i < 46; i++) {
        var a = (i * 2.399) % (Math.PI * 2);
        var rr = 22 + Math.sqrt((i + 1) / 46) * 120;
        stars.push({ a: a, r: rr });
      }

      if (mode === "brez") {
        // vse se premakne v isto smer - objekt uide iz polja
        var shift = (sec / 3600) * 15 * 6;
        stars.forEach(function (s) {
          var x = CX + Math.cos(s.a) * s.r, y = CY + Math.sin(s.a) * s.r;
          el("line", { x1: x, y1: y, x2: x + shift, y2: y, stroke: "#dce9fb", "stroke-width": "1.6", "stroke-linecap": "round", opacity: ".9" }, svg);
        });
        verdict.className = "ak-verdict is-bad";
        verdict.textContent = "Brez sledenja se vse premakne v isto smer. Že pri 30 sekundah so zvezde črtice, objekt pa uide iz polja.";
      } else if (mode === "azimut") {
        // sledi objektu, a polje se vrti okoli sredine
        stars.forEach(function (s) {
          var x1 = CX + Math.cos(s.a) * s.r, y1 = CY + Math.sin(s.a) * s.r;
          var x2 = CX + Math.cos(s.a + rad * 3) * s.r, y2 = CY + Math.sin(s.a + rad * 3) * s.r;
          el("path", { d: "M" + x1 + " " + y1 + " A" + s.r + " " + s.r + " 0 0 1 " + x2 + " " + y2,
            stroke: "#dce9fb", "stroke-width": "1.6", fill: "none", "stroke-linecap": "round", opacity: ".9" }, svg);
        });
        el("circle", { cx: CX, cy: CY, r: 3, fill: "#ffd08a" }, svg);
        verdict.className = "ak-verdict " + (sec <= 30 ? "is-warn" : "is-bad");
        verdict.textContent = sec <= 30
          ? "Azimutna montaža objekt drži na sredini, a polje se okoli njega vrti. Do 30 sekund je še sprejemljivo."
          : "Vrtenje polja: sredina je ostra, robovi so zavrteni v loke. Prav to je razlog, zakaj za fotografijo potrebujete ekvatorialno montažo.";
      } else {
        // pravilno poravnana ekvatorialna montaza - tocke ostanejo tocke
        stars.forEach(function (s) {
          var x = CX + Math.cos(s.a) * s.r, y = CY + Math.sin(s.a) * s.r;
          el("circle", { cx: x, cy: y, r: 1.7, fill: "#eef3fb", opacity: ".95" }, svg);
        });
        el("circle", { cx: CX, cy: CY, r: 3, fill: "#ffd08a" }, svg);
        verdict.className = "ak-verdict is-ok";
        verdict.textContent = "Ekvatorialna montaža, poravnana na nebesni pol, vrti teleskop okoli iste osi kot se vrti nebo. Zvezde ostanejo točke, tudi po nekaj minutah.";
      }

      el("text", { x: CX, y: H - 12, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "12" }, svg)
        .textContent = "eno okno posnetka · " + outExpo.textContent;
    }

    modeBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        mode = b.getAttribute("data-mode");
        modeBtns.forEach(function (x) { x.classList.toggle("is-on", x === b); });
        draw();
      });
    });
    expo.addEventListener("input", draw);
    draw();
  })();
})();
